import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { faDownload, faPrint, faCaretRight, faCaretLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icon from 'components/Icon';
import PropTypes from 'prop-types';
import Colors from 'constants/Colors';
import { Label } from 'components/Form';
import { FileContainer, FileHeader, ContPages, Actions, File, FileContent, FilePDF, FileTitle } from './styles';

const propTypes = {
    file: PropTypes.any
}

export default function FileModal({ file, color = Colors.PURPLE, isPDF = false }, ...props) {
    const [numDocuments, setNumDocuments] = useState(0);
    const [index, setIndex] = useState(0);
    const [isArray, setIsArray] = useState(false);

    function printDiv() {
        var printContents = document.getElementById("file").innerHTML;
        var originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;

        window.print();

        document.body.innerHTML = originalContents;
    };

    function handlePrevious() {
        if (index === 0) {
            return;
        }
        setIndex(index - 1);
    };

    function handleNext() {
        if ((index + 1) < numDocuments) {
            setIndex(index + 1);
        }
        return;
    };

    function handleOpenfile() {
        if (file[index].lnkAccess) {
            window.open(file[index].lnkAccess, '_blank');
        }
        return;
    };

    useEffect(() => {
        if (Array.isArray(file)) {
            setNumDocuments(file?.length);
            setIsArray(true);

        } else {
            setNumDocuments(1);
        }

    }, [file]);

    return (
        <FileContainer color={color}>
            {!file ? "" :
                <>
                    <FileHeader color={color}>
                        <FileTitle>
                            {file[index]?.title ? file[index].title : "File Name"}
                        </FileTitle>
                        <ContPages>
                            <Icon onClick={() => handlePrevious()} name={index === 0 ? "arrowLeftFade" : "arrowLeftWhite"} style={{ marginRight: "10px" }} />
                            Documento {index < numDocuments ? index + 1 : index} de {numDocuments/*file?.length*/}
                            <Icon onClick={() => handleNext()} name={(index + 1) < numDocuments ? "arrowRightWhite" : "arrowRightFade"} style={{ marginLeft: "10px" }} />
                        </ContPages>
                        {isPDF
                            ? <FileTitle></FileTitle>
                            : <Actions>
                                <Label onClick={() => { }/* printDiv() */}>
                                    <FontAwesomeIcon icon={faPrint} size='lg' color="#FFF" />
                                </Label>
                                <Label onClick={() => { }/*  handleOpenfile() */}>
                                    <FontAwesomeIcon icon={faDownload} size='lg' color="#FFF" />
                                </Label>
                            </Actions>}
                    </FileHeader>

                    <FileContent>
                        {isArray
                            ? isPDF
                                ? <FilePDF src={file[index]?.html} id="file" />
                                : <File dangerouslySetInnerHTML={file[index].title ? { __html: file[index].html } : { __html: file[index] }} id="file" />
                            : <File dangerouslySetInnerHTML={{ __html: file }} id="file" />
                        }
                    </FileContent>
                </>
            }
        </FileContainer >
    )

}

FileModal.propType = propTypes;
